import styled from '../../../../../../theme/styled';

const Dac7DropdownContainer = styled.div`
  position: relative;

  > aside {
    top: 0;
    padding: 0;
    margin: 0;
  }

  > div {
    position: absolute;
    top: 20px;
  }

  > .dac7-dropdown {
    a {
      text-decoration: none;
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

export default {
  Dac7DropdownContainer,
};
